import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'

function ProtectedRoute({ children, component: Component, ...rest }) {
    const user = useSelector(state => state.auth.user),
        path = window.location.href.replace(/^[^:]+:\/\/[^/]+/, '').replace(/#.*/, ''),
        redirectTo = path !== undefined && path.length > 1 ? ('?ret=' + encodeURI(path)) : "";
    console.log('redirectTo: ' + redirectTo);
    return user ? (<Route {...rest} component={Component} />) : (<Redirect to={'/auth/login-page' + redirectTo} />);
}

export default ProtectedRoute